<div style="display: flex;flex-direction: row;">
    <h2 mat-dialog-title style="display: inline;flex: auto;">Forretningsområde</h2>
    <button mat-button mat-dialog-close>X</button>
</div>
<mat-dialog-content>

    <div class="form-row">
        <mat-form-field appearance="outline">
            <mat-label>Navn</mat-label>
            <input matInput type="text" [(ngModel)]="department.name" required>
        </mat-form-field>
    </div>

    <div class="form-row">
      <mat-checkbox [(ngModel)]="department.includedInDashboard">Medtaget i dashboard</mat-checkbox>
    </div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="primary" mat-dialog-close>Annuller</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!department.name">Gem</button>
</mat-dialog-actions>